import React from 'react';

// Components
import Sidebar from '../../components/Sidebar';
import Form from './RemainStock/Form';

function RemainStock() {
  return (
    <div className="WarehouseStock">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              <Form
                name={'ตรวจสอบคืนถัง'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RemainStock;
